import { render, staticRenderFns } from "./epa-sectors.vue?vue&type=template&id=2c410213&scoped=true"
import script from "./epa-sectors.vue?vue&type=script&lang=js"
export * from "./epa-sectors.vue?vue&type=script&lang=js"
import style0 from "./epa-sectors.vue?vue&type=style&index=0&id=2c410213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c410213",
  null
  
)

export default component.exports